import produce from "immer";
import { IStoreState } from "..";
import { LoadState } from "../../constants/enums";
import {
  initialCategoryState,
  initialMasterCategoriesState,
  initialProductState,
} from "./masterCategories.types";
import { MasterCategoriesActions } from ".";
import {
  CLEAR_CATEGORY_STATE,
  CLEAR_MASTER_CATEGORIES_STATE,
  CLEAR_PRODUCT_STATE,
  FETCH_CATEGORY_LIST_FAILED,
  FETCH_CATEGORY_LIST_PROGRESS,
  FETCH_CATEGORY_LIST_SUCCESS,
  FETCH_PRODUCT_LIST_FAILED,
  FETCH_PRODUCT_LIST_PROGRESS,
  FETCH_PRODUCT_LIST_SUCCESS,
} from "./masterCategoriesActions";

export const masterCategoriesReducer = (
  state: IStoreState["masterCategories"] = initialMasterCategoriesState,
  action: MasterCategoriesActions,
) => {
  switch (action.type) {
    // Category Actions
    case FETCH_CATEGORY_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.category.loading = LoadState.InProgress;
        draftState.category.list = [];
        draftState.category.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_CATEGORY_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.category.loading = LoadState.Loaded;
        draftState.category.list = data;
        draftState.category.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_CATEGORY_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.category.loading = LoadState.Failed;
      });
      return newState;
    }
    case CLEAR_CATEGORY_STATE: {
      const newState = produce(state, (draftState) => {
        draftState.category = initialCategoryState;
      });
      return newState;
    }

    // Product Actions
    case FETCH_PRODUCT_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.product.loading = LoadState.InProgress;
        draftState.product.list = [];
        draftState.product.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_PRODUCT_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.product.loading = LoadState.Loaded;
        draftState.product.list = data;
        draftState.product.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_PRODUCT_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.product.loading = LoadState.Failed;
      });
      return newState;
    }
    case CLEAR_PRODUCT_STATE: {
      const newState = produce(state, (draftState) => {
        draftState.product = initialProductState;
      });
      return newState;
    }

    case CLEAR_MASTER_CATEGORIES_STATE: {
      return initialMasterCategoriesState;
    }
    default: {
      return state;
    }
  }
};
